<template>
    <!-- Footer
           ============================================= -->
    <footer id="footer" class="dark">
        <!-- Copyrights
        ============================================= -->
        <div id="copyrights">
            <div class="container">

                <div class="row justify-content-between col-mb-30">
                    <div class="col-12 col-lg-auto text-center text-lg-start order-first order-lg-last d-flex align-items-end">
                        SCFHS Health Academy &copy; 2023
                    </div>
                    <div class="col-12 col-lg-auto text-center">
                        <div class="copyrights-menu copyright-links text-white">
                            <span>{{$t("HomePage-ConnectWithUs")}}</span>
                        </div>
                        <a target="_blank" href="https://www.linkedin.com/company/saudi-commission-for-health-specialties-scfhs-/" class="social-icon inline-block si-colored si-borderless mb-0 si-linkedin">
                            <i class="icon-linkedin"></i>
                            <i class="icon-linkedin"></i>
                        </a>
                        <a @click="twitter" class="social-icon inline-block si-colored si-borderless mb-0 si-twitter">
                            <i class="icon-twitter"></i>
                            <i class="icon-twitter"></i>
                        </a>
                        <a target="_blank" href="https://www.youtube.com/channel/UCugoRV5IcPfaGTFLfacfCcQ" class="social-icon inline-block si-colored si-borderless mb-0 si-youtube">
                            <i class="icon-youtube"></i>
                            <i class="icon-youtube"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div><!-- #copyrights end -->
    </footer><!-- #footer end -->
</template>
<script>
    export default {
        name: 'footerComponent',
        methods: {
            twitter() {
                window.open("https://twitter.com/SchsOrg", "blank");
            }
        }
    }

</script>